(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forma-home"] && !Shopify.designMode) return;
  try {
    
function initializeProductRotation(root=document){
  root.querySelectorAll('[data-product-rotation]').forEach(carousel=>{
    if(carousel.dataset.ready)return;
    carousel.dataset.ready='true';
    const slides=Array.from(carousel.querySelectorAll('[data-rotation-slide]'));
    if(slides.length<2)return;
    const controls=carousel.querySelector('[data-rotation-controls]');
    const toggle=carousel.querySelector('[data-rotation-toggle]');
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,paused=reducedMotion.matches,hovered=false,focused=false;
    controls.hidden=false;
    const updateToggle=()=>{toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;};
    const show=next=>{
      const render=()=>{slides[index].hidden=true;index=(next+slides.length)%slides.length;slides[index].hidden=false;carousel.querySelector('[data-rotation-count]').textContent=(index+1)+' / '+slides.length;};
      if(document.startViewTransition&&!reducedMotion.matches)document.startViewTransition(render);else render();
    };
    carousel.querySelector('[data-rotation-previous]').addEventListener('click',()=>{paused=true;updateToggle();show(index-1);});
    carousel.querySelector('[data-rotation-next]').addEventListener('click',()=>{paused=true;updateToggle();show(index+1);});
    toggle.addEventListener('click',()=>{paused=!paused;updateToggle();});
    carousel.addEventListener('mouseenter',()=>{hovered=true;});
    carousel.addEventListener('mouseleave',()=>{hovered=false;});
    carousel.addEventListener('focusin',()=>{focused=true;});
    carousel.addEventListener('focusout',event=>{focused=carousel.contains(event.relatedTarget);});
    reducedMotion.addEventListener('change',event=>{if(event.matches){paused=true;updateToggle();}});
    updateToggle();
    const timer=window.setInterval(()=>{if(!carousel.isConnected){window.clearInterval(timer);return;}if(!paused&&!hovered&&!focused&&!document.hidden)show(index+1);},6000);
  });
}
initializeProductRotation();
document.addEventListener('shopify:section:load',event=>initializeProductRotation(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
